import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output,
} from '@angular/core';

@Component({
  selector: 'app-aside',
  templateUrl: './aside.component.html',
  styleUrls: ['./aside.component.scss'],
})
export class AsideComponent implements OnInit {
  @Input() opened: any;
  @Output() isClose: any = new EventEmitter();
  @Output() scrolled: any = new EventEmitter();
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event) {
    if (!this.opened) {
      return;
    }

    const clickedElement = event.target as HTMLElement;

    const sidenavElement =
      this.elementRef.nativeElement.querySelector('.aside-right');

    if (sidenavElement && sidenavElement.contains(clickedElement)) {
      return;
    }

    this.close();
  }

  close() {
    this.opened = false;
    this.isClose.emit(false);
  }

  constructor(private elementRef: ElementRef) {}

  ngOnInit() {}

  onScroll() {
    this.scrolled.emit();
  }

  onBackDropClick() {
    this.close();
  }
}
